import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

export type Amount = {
  value: number
  currencyCode: string
}

export type Address = {
  streetNumberAndName: string
  apartmentNumber: string
  city: string
  zipCode: string
  state: string
  country: string
}

export type Attachment = {
  id: string
  name: string
}

export type TransactionsTransferDetailsApiResponse = {
  externalTransferId: string
  status: string
  amount: Amount
  date: string
  senderName: string
  recipientName: string
  selectedAccount: string
  senderAccount: string
  recipientAccount: string
  isRefunded: boolean
  isReimbursed: boolean
  appliedForReimbursement: boolean
  recipientAddress: Address
  attachments: Attachment[]
}

type HookParams = {
  transferId: string | null
}

export function useTransactionTransferDetails({ transferId }: HookParams) {
  return useQuery<TransactionsTransferDetailsApiResponse>({
    queryKey: ["transactionDetails", transferId],
    queryFn: async () => {
      const response = await fetcher(
        `/Transaction/${transferId}`,
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()

      return responseJson ?? {}
    },
    enabled: transferId !== null,
  })
}
